// extracted by mini-css-extract-plugin
export default {"gameoverPop":"gameOverPop_gameoverPop__ZmCEb","price":"gameOverPop_price__MP-JD","contentWrpper":"gameOverPop_contentWrpper__pvJ8a","congratsPop":"gameOverPop_congratsPop__yE0Ly"};